import type { RecurrencePlan } from '@entities/product/api/product.contract'

export function recurrencePlanRequestBody(plan: RecurrencePlan) {
  const benefits = (plan.benefits ?? [])
    .map((benefit) => benefit.trim())
    .filter((benefit) => benefit.length > 0)
  const description = plan.description?.trim() ?? ''

  return {
    name: plan.name.trim() || 'Plano de assinatura',
    ...(description.length > 0 ? { description } : {}),
    benefits,
    value: plan.value,
    active: plan.active,
    billing: {
      billingPeriodUnit: plan.billingPeriodUnit,
      billingPeriodCount: plan.billingPeriodCount,
      billingAnchorType: plan.billingAnchorType,
      ...(plan.billingAnchorType === 'CALENDAR' && plan.billingAnchorDayOfMonth !== null
        ? { billingAnchorDayOfMonth: plan.billingAnchorDayOfMonth }
        : {}),
    },
    trial: {
      isTrialEnabled: plan.trialEnabled,
      ...(plan.trialEnabled
        ? {
            trialType: plan.trialType,
            trialDays: plan.trialDays,
            ...(plan.trialType === 'PAID' ? { trialPrice: plan.trialPrice } : {}),
          }
        : {}),
    },
    retry: {
      maxRetryAttempts: plan.retryAttempts,
      fixedDelayDays: plan.retryDelayDays,
    },
    grace: {
      gracePeriodEnabled: plan.graceEnabled,
      gracePeriodDays: plan.graceEnabled ? plan.graceDays : 0,
    },
  }
}
